import MaterialIcon from '@material/react-material-icon';
import { Button } from '@upmc/ims.component-library';
import styles from '../../../../../../ApplicationMaintenance.module.scss';
import { useState } from 'react';
import Modal from '@mui/material/Modal';
import Base from '../../../../../../../Base/Base';
import Spinner from '../../../../../../../../components/UI/Spinner/Spinner';
import ApiErrors from '../../../../../../components/NewApplication/ApiErrors';
import Section from '../../../../../../components/NewApplication/Section';
import AppExtensionForm from '../AppExtensionCreate/AppExtensionForm';
import { AppExtension } from '../../../../../../../../Classes/ResponseModels/ApplicationManagement/AppManagementModel';
import { UpdateAppExtension } from '../../../../../../_api';
import AppExtensionRequest from '../../../../../../../../Classes/ResponseModels/ApplicationManagement/AppExtensionRequest';
import { APPROVAL_WORKFLOW_TYPES } from '../../../../_constants';
//AppExtension : AppExtension api model (gets converted on initial load to AppExtension client model)
const AppExtensionUpdate = ({
	appExtension,
	setAppExtensions,
	app,
	currentUser,
	readOnly,
	requirementNumber,
}) => {
	//modal component, on save should update the AppExtension
	const [modalOpen, setModalOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [apiErrors, setApiErrors] = useState([]);
	const [localAppExtension, setLocalAppExtension] = useState(
		new AppExtension({ ...appExtension })
	);

	const handleSave = () => {
		setIsLoading(true);
		let request = new AppExtensionRequest(
			app,
			currentUser,
			APPROVAL_WORKFLOW_TYPES.MultiLevel,
			null,
			app.appExtensions,
			localAppExtension,
			requirementNumber
		);
		UpdateAppExtension(request)
			.then(response => {
				setAppExtensions(response.applicationExtensions);
				setApiErrors(response.App.errors);
			})
			.then(x => {
				setIsLoading(false);
				setModalOpen(false);
			});
	};

	const handleChange = e => {
		setLocalAppExtension({
			...localAppExtension,
			[e.target.name]: e.target.value,
		});
	};

	return (
		<div>
			<div>
				<Button
					id='app_extension_create_modal_open'
					onClick={() => setModalOpen(true)}
					startIcon={<MaterialIcon icon='edit' />}
					disabled={readOnly}
				>
					Edit
				</Button>
				<Modal
					open={modalOpen}
					onClose={() => {
						setModalOpen(false);
					}}
				>
					<div className={styles.Modal}>
						<Base title='Edit App Extension'>
							{isLoading ? (
								<Spinner />
							) : (
								<>
									<ApiErrors errors={apiErrors} />
									<div className={styles.controlsContainer}>
										<Button
											onClick={e => {
												handleSave();
											}}
											startIcon={
												<MaterialIcon icon='save' />
											}
											id='createAppExtension_Save'
										>
											Save
										</Button>
									</div>
									<Section label='Update App Extension'>
										<AppExtensionForm
											appExtension={localAppExtension}
											handleChange={handleChange}
											app={app}
										/>
									</Section>
								</>
							)}
						</Base>
					</div>
				</Modal>
			</div>
		</div>
	);
};

export default AppExtensionUpdate;
